import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ScanResult } from '../types/index';

export const exportToPDF = (result: ScanResult): void => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    // Title
    doc.setFontSize(20);
    doc.setTextColor(31, 41, 55); // gray-800
    doc.text('Accessibility Scan Report', 14, 20);

    // URL and Date
    doc.setFontSize(10);
    doc.setTextColor(107, 114, 128); // gray-500
    doc.text(`URL: ${result.url}`, 14, 28);
    doc.text(`Scanned: ${new Date(result.timestamp).toLocaleString()}`, 14, 33);
    doc.text(`Duration: ${(result.scanDuration / 1000).toFixed(1)}s`, 14, 38);

    // Summary Box
    doc.setFillColor(249, 250, 251); // gray-50
    doc.rect(14, 45, pageWidth - 28, 35, 'F');

    doc.setFontSize(14);
    doc.setTextColor(31, 41, 55);
    doc.text('Summary', 18, 53);

    doc.setFontSize(10);
    doc.text(`Total Issues: ${result.summary.totalIssues}`, 18, 60);
    doc.text(`Critical: ${result.summary.criticalIssues}`, 18, 66);
    doc.text(`Serious: ${result.summary.seriousIssues}`, 80, 66);
    doc.text(`Moderate: ${result.summary.moderateIssues}`, 18, 72);
    doc.text(`Minor: ${result.summary.minorIssues}`, 80, 72);

    // WCAG Level
    const wcagColor = result.summary.wcagLevel === 'AAA' ? [16, 185, 129] :
        result.summary.wcagLevel === 'AA' ? [251, 191, 36] : [239, 68, 68];
    doc.setTextColor(wcagColor[0], wcagColor[1], wcagColor[2]);
    doc.text(`WCAG Level: ${result.summary.wcagLevel}`, 140, 60);

    doc.setTextColor(107, 114, 128);
    doc.text(`Section 508: ${result.summary.section508Compliant ? 'Compliant' : 'Non-Compliant'}`, 140, 66);

    // Issues Table
    let yPosition = 90;

    if (result.issues.axeIssues.length > 0) {
        doc.setFontSize(12);
        doc.setTextColor(31, 41, 55);
        doc.text('Accessibility Violations', 14, yPosition);
        yPosition += 5;

        const tableData = result.issues.axeIssues.map(issue => [
            issue.impact.toUpperCase(),
            issue.help,
            issue.nodes.length.toString(),
            issue.wcagLevel
        ]);

        autoTable(doc, {
            startY: yPosition,
            head: [['Impact', 'Issue', 'Elements', 'WCAG']],
            body: tableData,
            theme: 'striped',
            headStyles: {
                fillColor: [99, 102, 241], // primary-600
                textColor: [255, 255, 255],
                fontSize: 9
            },
            bodyStyles: {
                fontSize: 8
            },
            columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 100 },
                2: { cellWidth: 20 },
                3: { cellWidth: 20 }
            }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;
    }

    // Color Contrast Issues
    if (result.issues.colorContrastIssues.length > 0 && yPosition < 250) {
        doc.setFontSize(12);
        doc.setTextColor(31, 41, 55);
        doc.text('Color Contrast Issues', 14, yPosition);
        yPosition += 5;

        const contrastData = result.issues.colorContrastIssues.map(issue => [
            issue.element,
            issue.text.substring(0, 50),
            'Low Contrast'
        ]);

        autoTable(doc, {
            startY: yPosition,
            head: [['Element', 'Text', 'Issue']],
            body: contrastData,
            theme: 'striped',
            headStyles: {
                fillColor: [251, 146, 60], // orange-500
                textColor: [255, 255, 255],
                fontSize: 9
            },
            bodyStyles: {
                fontSize: 8
            }
        });
    }

    // Save PDF
    doc.save(`accessibility-scan-${new Date().toISOString().split('T')[0]}.pdf`);
};
